import { h, Component } from 'preact';
import dlv from 'dlv';

import { trackEvent, STANDARD_KEYS, INPUT_KEYS } from '@cube/track';

/** Creates div for taboola js insertion
 */
export class TaboolaJs extends Component {

	trackClick = (e) => {
		trackEvent(this.context, {
			[INPUT_KEYS.action]: 'click',
			[INPUT_KEYS.priority]: 'high',
			[STANDARD_KEYS.contenturl]: dlv(e, 'srcElement.parentNode.parentNode.href'),
			[STANDARD_KEYS.contenttext]: dlv(e, 'srcElement.parentNode.parentNode.title'),
			[STANDARD_KEYS.contentsource]: 'Taboola' + (dlv(e, 'srcElement.parentNode.parentNode.target') === '_blank' ? '-Sponsored' : '-Organic')
		});
	}

	componentDidMount() {
		if (this.props.taboolaJsParams && window._taboola) {
			window._taboola.push({
				container: this.props.id,
				...this.props.taboolaJsParams
			});
		}
	}

	shouldComponentUpdate = () => false;

	render({ id, class: divClass, qeId, ...rest }) {
		if (rest.taboolaJsParams) delete rest.taboolaJsParams;
		return <div onClick={this.trackClick} id={id} class={divClass} qid={qeId} {...rest} />;
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/dcc-widget-v2/src/components/taboola-js/index.js